import React from 'react';

import Container from './Container';
import classNames from '../utils/classNames';

import type { JSX } from 'react';

const PageIntro = ({
  eyebrow,
  title,
  children,
  centered = false,
}: {
  eyebrow: string;
  title: string;
  children: React.ReactNode;
  centered?: boolean;
}): JSX.Element => (
  <Container
    className={classNames('mt-24 sm:mt-32 lg:mt-40', centered && 'text-center')}
  >
    <div>
      <h1>
        <span className="block font-display text-base font-semibold text-neutral-950">
          {eyebrow}
        </span>
        <span className="sr-only"> - </span>
        <span
          className={classNames(
            'mt-6 block max-w-5xl font-display text-5xl font-medium tracking-tight',
            'text-balance text-neutral-950 sm:text-6xl',
            centered && 'mx-auto',
          )}
        >
          {title}
        </span>
      </h1>
      <div
        className={classNames(
          'mt-6 max-w-3xl text-xl text-neutral-600',
          centered && 'mx-auto',
        )}
      >
        {children}
      </div>
    </div>
  </Container>
);

PageIntro.defaultProps = {
  centered: false,
};

export default PageIntro;
